import React from 'react';
import CommonTagsInputWrapper from './CommonTagsInputWrapper';

class TagsUrlInputWrapper extends React.Component {
  renderTagValue = tagValue => {
    return (
      <a href={this.props.urlTagLink(tagValue)} target="_blank" className="urlTagLink">
        {tagValue}
      </a>
    );
  };

  render() {
    return <CommonTagsInputWrapper {...this.props} renderTagValue={this.renderTagValue} />;
  }
}

export default TagsUrlInputWrapper;
